import { useTranslation } from 'react-i18next';
import { Box } from '@chakra-ui/react';

import useDeleteLiveAccount from 'Domain/live-account/useDeleteLiveAccount';
import { useModal } from 'Store/modal';
import { TextRegular } from 'UiKit/typography';

const useOpenDeleteModal = () => {
  const { t } = useTranslation('live-account');
  const { onOpenModal } = useModal();

  const { mutate: onDeleteLiveAccount } = useDeleteLiveAccount();

  const buildDescription = () => (
    <Box>
      <TextRegular>{t('deleteModalContentPrefix')}</TextRegular>
      <ul style={{ marginLeft: '32px' }}>
        <li>
          <TextRegular>{t('deleteModalContentBullet1')}</TextRegular>
        </li>
        <li>
          <TextRegular>{t('deleteModalContentBullet2')}</TextRegular>
        </li>
      </ul>
      <br />
      <TextRegular>{t('deleteModalContentSuffix')}</TextRegular>
    </Box>
  );

  const onOpenDeleteModal = (id) => {
    onOpenModal({
      width: '400px',
      isOpen: true,
      type: 'cancel',
      title: t('deleteModalTitle'),
      contentDescription: buildDescription(),
      showPrimaryButton: true,
      showSecondaryButton: true,
      primaryButtonText: t('deleteModalConfirmButton'),
      secondaryButtonText: t('deleteModalCancelButton'),
      onClickPrimaryButton: () => onDeleteLiveAccount(id),
    });
  };

  return { onOpenDeleteModal };
};

export default useOpenDeleteModal;